import { ArrowRight } from "lucide-react";
import { useSimulator } from "./SimulatorContext";
import { nodeTypeLabel } from "./labels";
import { displayStepNumber, mainStepCount } from "./tracePresentation";
import type { IExecutionStep } from "../../interfaces";

export default function SimulatorExplain() {
  const { state } = useSimulator();
  const { steps, currentStepIndex, isStarted, isFinished } = state;

  const currentStep: IExecutionStep | null =
    currentStepIndex >= 0 && currentStepIndex < steps.length
      ? steps[currentStepIndex]
      : null;

  if (!isStarted) {
    return (
      <div className="p-3">
        <p className="text-xs text-muted-foreground text-center py-4">
          Inicie a execução para ver as explicações de cada passo.
        </p>
      </div>
    );
  }

  if (!currentStep) return null;

  return (
    <div className="p-3 space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-[10px] font-semibold text-muted-foreground uppercase tracking-wider">
          Passo {displayStepNumber(steps, currentStepIndex)} de {mainStepCount(steps)}
        </span>
        <span className="text-[10px] px-2 py-0.5 rounded-full bg-primary/10 text-primary font-semibold">
          {nodeTypeLabel(currentStep.nodeType)}
        </span>
      </div>
      <div className="rounded-lg border border-primary/20 bg-primary/5 p-3">
        <p className="text-xs leading-relaxed text-foreground">
          {currentStep.explanation}
        </p>
      </div>
      {currentStep.changes.length > 0 && (
        <div className="space-y-1">
          <span className="text-[10px] font-semibold text-muted-foreground uppercase tracking-wider">
            O que mudou:
          </span>
          <div className="space-y-0.5">
            {currentStep.changes.map((change, i) => (
              <div
                key={i}
                className="flex items-center gap-1.5 text-xs font-mono bg-emerald-50 border border-emerald-200 rounded px-2 py-1 text-emerald-800"
              >
                <ArrowRight className="w-3 h-3 shrink-0 text-emerald-600" />
                {change}
              </div>
            ))}
          </div>
        </div>
      )}
      {currentStep.waitingForInput && (
        <div className="rounded-md bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-800/30 px-3 py-2">
          <p className="text-[11px] text-amber-700 dark:text-amber-400 font-medium">
            Aguardando entrada do usuário...
          </p>
          <p className="text-[10px] text-amber-600 dark:text-amber-500 mt-0.5">
            {currentStep.inputPrompt}
          </p>
        </div>
      )}
      {!isFinished && (
        <div className="rounded-md bg-muted/50 px-3 py-2">
          <p className="text-[11px] text-muted-foreground italic">
            {currentStep.nextHint}
          </p>
        </div>
      )}
    </div>
  );
}
